export class ConfigDB {
  static data = {
    settings: {
      layout_type: "ltr",
      sidebar: {
        type: "compact-wrapper",
      },
      sidebar_setting: "default-sidebar",
    },
    color: {
      primary_color: "#5f7dc4",
      secondary_color: "#c29873",
      mix_background_layout: "light-only",
    },
    router_animation: "fadeIn",
  };
  static updateData(newData) {
    console.log("newData", newData);
    this.data = newData;
  }
}
export default ConfigDB;
